import React from 'react'

interface DownwardArrowProps {
  className?: string;
}

const DownwardArrow: React.FC<DownwardArrowProps> = ({ className }) => {
  return (
    <svg       className={className}
    xmlns="http://www.w3.org/2000/svg" width="9" height="24" viewBox="0 0 9 15" fill="none">
  <path d="M8.32031 6.19043C8.3724 6.24251 8.39844 6.30241 8.39844 6.37012C8.39844 6.43783 8.3724 6.49772 8.32031 6.5498L4.67969 10.1904C4.6276 10.2425 4.56771 10.2686 4.5 10.2686C4.43229 10.2686 4.3724 10.2425 4.32031 10.1904L0.679688 6.5498C0.627604 6.49772 0.601562 6.43783 0.601562 6.37012C0.601562 6.30241 0.627604 6.24251 0.679688 6.19043L1.07031 5.7998C1.1224 5.74772 1.18229 5.72168 1.25 5.72168C1.31771 5.72168 1.3776 5.74772 1.42969 5.7998L4.5 8.87012L7.57031 5.7998C7.6224 5.74772 7.68229 5.72168 7.75 5.72168C7.81771 5.72168 7.8776 5.74772 7.92969 5.7998L8.32031 6.19043Z" fill="#101D2C"/>
</svg>
  )
}

export default DownwardArrow